import { takeLatest, call, put, takeEvery } from 'redux-saga/effects';
import { List } from 'immutable';
import { AxiosResponse } from 'axios';

import * as types from './types';
import { ErrorUtils } from 'utils';
import { addErrorMessage, addSuccessMessage } from 'features/message/redux/action';
import {
  removeGiftCardAction,
  requestGetGiftCardsAction,
  requestRemoveGiftCardAction,
  setGiftCardsAction,
  setGiftCardsLoadingAction,
} from 'features/my-gift-cards/redux/action';
import { deleteGiftCardRequest as removeGiftCardRequest, getMyGiftCardsRequest } from 'features/my-gift-cards/api';
import type { ShortBrandedGiftCard } from 'features/my-gift-cards/ts/ShortBrandedGiftCard';
import { t } from 'locales/i18n';

function* giftCardsRequestSaga(action: ReturnType<typeof requestGetGiftCardsAction>) {
  if (action.payload.setIsLoading) yield put(setGiftCardsLoadingAction(true));

  try {
    const { data } = (yield call(getMyGiftCardsRequest, action.payload.filters)) as AxiosResponse<
      ShortBrandedGiftCard[]
    >;
    yield put(setGiftCardsAction(List(data)));
  } catch (error) {
    const message = ErrorUtils.convertError(error);
    yield put(addErrorMessage(message));
  }
  yield put(setGiftCardsLoadingAction(false));
}

function* creationSuccessSaga() {
  yield put(addSuccessMessage(t('messages.creationSuccess', { ns: 'my-gift-cards' })));
}

function* updateSuccessSaga() {
  yield put(addSuccessMessage(t('messages.editSuccess', { ns: 'my-gift-cards' })));
}

function* removeGiftCardSaga(action: ReturnType<typeof requestRemoveGiftCardAction>) {
  yield put(setGiftCardsLoadingAction(true));
  try {
    yield call(removeGiftCardRequest, action.payload);
    yield put(removeGiftCardAction(action.payload));
    yield put(addSuccessMessage(t('messages.cardRemoved', { ns: 'my-gift-cards' })));
  } catch (error) {
    const message = ErrorUtils.convertError(error);
    yield put(addErrorMessage(message));
  }
  yield put(setGiftCardsLoadingAction(false));
}

function* myGiftCardsSaga() {
  yield takeLatest(types.GET_GIFT_CARDS_REQUEST, giftCardsRequestSaga);
  yield takeEvery(types.CREATE_GIFT_CARD, creationSuccessSaga);
  yield takeEvery(types.UPDATE_GIFT_CARD, updateSuccessSaga);
  yield takeEvery(types.REMOVE_GIFT_CARD_REQUEST, removeGiftCardSaga);
}

export default myGiftCardsSaga;
